export var FETCH_SUBSCRIBE_STATUS = 'FETCH_SUBSCRIBE_STATUS';
export var SUCCESS_FETCH_SUBSCRIBE_STATUS = 'SUCCESS_FETCH_SUBSCRIBE_STATUS';
export var FAILURE_FETCH_SUBSCRIBE_STATUS = 'FAILURE_FETCH_SUBSCRIBE_STATUS';
export var CREATE_SUBSCRIBE_CAMPAIGN = 'CREATE_SUBSCRIBE_CAMPAIGN';
export var SUCCESS_CREATE_SUBSCRIBE_CAMPAIGN = 'SUCCESS_CREATE_SUBSCRIBE_CAMPAIGN';
export var FAILURE_CREATE_SUBSCRIBE_CAMPAIGN = 'FAILURE_CREATE_SUBSCRIBE_CAMPAIGN';



// WEBPACK FOOTER //
// ./src/actions/bonus/subscribeCampaignAction.js